var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 21h4v-4.5c0-.828.672-1.5 1.5-1.5h5c.828 0 1.5.672 1.5 1.5V21h4v-7.55l-8-7.112-8 7.111V21zm6-4v6H4v-9.775c0-.429.183-.837.503-1.122l8.5-7.555c.569-.505 1.425-.505 1.994 0l8.5 7.555c.32.285.503.693.503 1.122V23h-8v-6h-4z",
    transform: "translate(-20.000000, -157.000000) translate(20.000000, 157.000000)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.69d173d07b1b3b87c71e99d7bbddd22e.svg";
export { ForwardRef as ReactComponent };